import React, { Component } from "react";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarRecursoDs } from "../../DataSources";
import {
  DataGrid,
  StateStoring,
  FilterRow,
  Editing,
  Column,
  Paging,
  Pager,
  Lookup
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import memoria from "../../Memoria";
import UserInfo from "../../UserInfo.js";
import apiAxios from "../../api-axios";
import notify from "devextreme/ui/notify";

const localStorageKey = "cadastroRecursoGridState";

export default class RecursoBox extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.recursoDs = criarRecursoDs();
    this.onSelecionado = props.onSelecionado;
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.state = { grupos: {} };
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("recursos/editar/" + e.data.id);
  }

  async componentDidMount() {
    memoria.redirecionarSeNecessario(this.props.location, this.props.history);

    const response = await apiAxios.get(
      "/grupo_recursos/prefeitura/" + UserInfo.getPrefeitura()
    );
    this.setState({ ...this.state, grupos: response.data.data });

    console.log(this.state.grupos)
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <PaginaToolbar titulo="Recurso" novoCb={this.novoRecurso.bind(this)}>
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={criarRecursoDs()}
              showBorders={true}
              rowAlternationEnabled={true}
              focusedRowEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
              onEditingStart={this.onAtualizandoRow}
            >
              <FilterRow visible={true} />
              <Editing
                allowDeleting={!this.usadoComoPesquisa}
                allowUpdating={true}
                useIcons={true}
                visible={!this.usadoComoPesquisa}
              />
              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                buttons={[
                  "edit",
                  "delete",
                  {
                    hint: "Selecionar",
                    icon: "repeat",
                    visible: this.usadoComoPesquisa,
                    onClick: this.onSelecionado,
                  },
                ]}
              />
              <Column dataField={"id"} caption={"ID"} alignment={"left"} sortIndex={1} sortOrder={"desc"} width={120} alignment={"center"}/>
              <Column dataField={"modulo"} caption={"Módulo"} visible={false}/>
              <Column dataField={"nome"} />
              <Column dataField={"tipo"} visible={false}/>
              <Column dataField={"linkFrontEnd"} caption={"Link"} visible={false}/>
              <Column dataField={"gruposStr"} caption={"Grupos"} />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

              <Pager
                showInfo={true}
                showNavigationButtons={true}
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novoRecurso() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("recursos/novo");
  }
}
